<mat-card appearance="outlined">
	<h4 class="title">Your order</h4>
	<div class="address-info" *ngIf="_serviceAddress">
		<img
			class="address-icon"
			alt=""
			src="/assets/img/icons/icon-map-pin-purple.svg"
		/>
		<span class="address-text">
			{{ _capitalizeFirstLetter(_serviceAddress) }}
		</span>
	</div>
	<div *ngIf="_loaded && _cartItemGroups && _cartItemGroups.length > 0">
		<cart-item-group
			*ngFor="let cartItemGroup of _cartItemGroups"
			[cartItemGroup]="cartItemGroup"
		></cart-item-group>
	</div>
	<div
		class="total"
		*ngIf="_cartTotal.dueToday >= 0 || _cartTotal.monthly >= 0"
	>
		<div class="total-row total-cost">
			<div
				class="total-text"
				[innerHTML]="_totalCostLabel"
				*ngIf="
					!(
						_cartTotal.promoDiscountDurationTextDiscount &&
						_cartTotal.promoDiscountDurationTextDiscount.length > 0
					)
				"
			>
				<!-- Due now* -->
			</div>
			<div
				class="total-text"
				*ngIf="
					_cartTotal.promoDiscountDurationTextDiscount &&
					_cartTotal.promoDiscountDurationTextDiscount.length > 0
				"
			>
				<span>
					{{ _totalCostLabel }}
				</span>
				<span
					class="_totalMonthlyCostForFirstXMonths"
					[innerHTML]="_totalMonthlyCostForFirstXMonths"
				>
					{{ _totalMonthlyCostForFirstXMonths }}</span
				>
			</div>

			<total-value-display
				[value]="formatPriceValue(_cartTotal.monthly)"
			></total-value-display>
		</div>

		<div
			class="total-row total-cost total-monthly-cost-after-x-months"
			*ngIf="
				_cartTotal.promoDiscountValue &&
				_cartTotal.promoDiscountDurationText &&
				_cartTotal.promoDiscountValue > 0
			"
		>
			<div
				[innerHTML]="_cartTotal.promoDiscountDurationText"
				class="total-text total-monthly-cost-after-x-months-text"
			>
				<!-- totalCostAfterXMonths -->
			</div>

			<total-value-display
				[totalCostAfterXMonths]="
				formatPriceValue(_cartTotal.promoDiscountValue + _cartTotal.monthly)
				"
			></total-value-display>
		</div>

		<div class="total-row total-cost" *ngIf="_cartTotal.dueToday >= 0">
			<div class="total-text" *ngIf="_monthToMonthSetupFee === 0">
				{{
					source && source === "thankyou"
						? "Paid today:"
						: "Due now:"
				}}
			</div>

			<div class="total-text" *ngIf="_monthToMonthSetupFee > 0">
				<span>
					{{
						source && source === "thankyou"
							? "Paid today:"
							: "Due now:"
					}}
				</span>
				<span
					class="_totalMonthlyCostForFirstXMonths"
					[innerHTML]="'(incl. one-off charges)'"
				>
				</span>
			</div>
			<total-value-display
				[value]="formatPriceValue(_cartTotal.dueToday)"
			></total-value-display>
		</div>

		<div
			class="total-row total-cost total-monthly-cost-after-x-months"
			*ngIf="
				_monthToMonthSetupFee > 0 &&
				_cartTotal.dueToday - _monthToMonthSetupFee > 0
			"
		>
			<div
				[innerHTML]="'First month of service:'"
				class="total-text total-monthly-cost-after-x-months-text"
			></div>

			<total-value-display
				[totalCostAfterXMonths]="
				formatPriceValue(products[0]?.product?.newDevelopmentFee ? _cartTotal.dueToday - _monthToMonthSetupFee -100 : _cartTotal.dueToday - _monthToMonthSetupFee)
				"
			></total-value-display>
		</div>

		<div
			class="total-row total-cost total-monthly-cost-after-x-months"
			*ngIf="_monthToMonthSetupFee > 0"
		>
			<div
				[innerHTML]="'Set-up fee:'"
				class="total-text total-monthly-cost-after-x-months-text"
			></div>

			<total-value-display
				[totalCostAfterXMonths]="
					formatPriceValue(_monthToMonthSetupFee)
				"
			></total-value-display>
		</div>

	</div>
</mat-card>
